import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage" // defaults to localStorage for web
import rootReducer from "./reducers/rootReducer" // Import your root reducer

// Configuration for redux-persist
const persistConfig = {
  key: "root",
  storage,
}

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer)

// Configure the store
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      // Ignore these action types
      ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
    },
  }),
})

// Create a persistor
const persistor = persistStore(store)

export { store, persistor }
